<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog_status"
      scrollable max-width="400px"
      @keydown.esc="close()">

      <v-card v-if="!success">

        <!-- Title -->
        <v-card-title>
          {{ $t('issues.report_issue') }}
        </v-card-title>

        <!-- Text -->
        <v-card-text>

          <div class="kind-title">
            <span>{{ $t('issues.what_kind') }}</span>
            <span class="required">*</span>
          </div>

          <v-radio-group v-model="type">
            <v-radio v-for="(value, key) in ticket_types" :key="key"
              :value="parseInt(value.id)">
              <template v-slot:label>
                {{ $t('issues.' + value.name) }}
              </template>
            </v-radio>
          </v-radio-group>

          <div class="issue-details">
            <div class="issue">
              <div class="kind-title">
                {{ $t('issues.write_down') }}
              </div>

              <div>
                <div>
                  <span>{{ $t('issues.title') }}</span>
                  <span class="required">*</span>
                </div>
                <v-text-field outlined v-model="title"
                  placeholder="Title">
                </v-text-field>
              </div>

              <div>
                <div>
                  <span>{{ $t('issues.description') }}</span>
                  <span class="required">*</span>
                </div>
                <v-textarea outlined v-model="description"
                  placeholder="Describe the issue">
                </v-textarea>
              </div>
            </div>
          </div>

          <!-- Error message -->
          <div v-if="error">
            {{ $t('issues.try_again') }}
          </div>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn small text @click="close()">
              {{ $t('issues.cancel') }}
            </v-btn>
            <v-btn small depressed color="primary"
              @click="saveTicket()"
              :disabled="!confirm">
              {{ $t('issues.save') }}
            </v-btn>
        </v-card-actions>

      </v-card>

      <v-card v-else>
        
        <v-card-title>
          {{ $t('issues.success') }}
        </v-card-title>

        <v-card-text>
          {{ $t('issues.success_text') }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="close()">
            {{ $t('issues.cancel') }}
          </v-btn>
          <v-btn @click="checkMyIssue()"
            small depressed color="primary">
            {{ $t('issues.check_my_issue') }}
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>
  </v-layout>
</template>

<script>
import { ticket_types } from '../../custom/model'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      ticket_types,

      title: '',
      description: '',
      type: 1,
      tk_id: null,

      success: false,
      error: false,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    confirm() {
      return !!this.title.length && 
        !!this.description.length
    },
  },

  methods: {
    
    close() {
      this.type = 1
      this.title = ''
      this.description = ''
      this.error = false
      this.success = false
      this.$emit('update:dialog', false)
    },

    async saveTicket() {
      try {
        await this.$store.dispatch('ticket/createMyTicket', {
          title: this.title,
          description: this.description,
          type: this.type,
        })
      } catch(e) {
        this.error = true
      } finally {
        if(!this.error) {
          this.tk_id = this.$store.getters['ticket/tk_id']
          this.success = true
          this.$analytics.logEvent('click', { name: 'reportIssue_btn_create' })
        }
      }
    },

    checkMyIssue() {
      this.$router.push({ name: 'issue', params: { id: this.tk_id } })
      this.close()
    },

  },
}
</script>

<style scoped>

  .kind-title {
    margin-bottom: 6px;
  }

</style>



// WEBPACK FOOTER //
// src/components/modal/ReportIssue.vue